import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH_M, TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
import { generateCloudinaryImageUrl } from "services/community/cloudinary-service";
import { LAYER_ONE, TOP_LAYER } from "constants/z-index";
import Colors from "/styles/colors";
import colors from "/styles/colors";
import { BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01, BRAND_WORK_MANAGEMENT_PRIMARY_COLOR, WHITE_COLOR_NAME, WORK_OS_IRIS_COLOR_NAME, DARK_WORK_OS_IRIS_COLOR_NAME, BRAND_PRIMARY_YELLOW, BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH } from "/constants/vp-sizes";
import { bulmaStyles } from "components/pages/careers/bulma.scss";
import { careersCommonStyles } from "components/pages/careers/careers-common-style.scss";
import { slickThemeStyle } from "components/pages/careers/slick-theme.scss";
import { slickStyle } from "components/pages/careers/slick.scss";
export const StyledPositionComponent = styled.div`
  ${bulmaStyles}
  ${careersCommonStyles}
  
  .basic-header-component {
    a {
      color: ${Colors["black"]};
    }

    a:hover {
      color: ${Colors[DARK_WORK_OS_IRIS_COLOR_NAME]};
    }

    .button,
    .button:hover {
      background-color: revert;
      border-color: revert;
      border-width: revert;
      color: revert;
      cursor: revert;
      justify-content: revert;
      text-align: revert;
      white-space: revert;
      -moz-appearance: revert;
      -webkit-appearance: revert;
      align-items: revert;
      border: revert;
      border-radius: revert;
      box-shadow: revert;
      display: revert;
      font-size: revert;
      height: revert;
      justify-content: revert;
      line-height: revert;
      padding-bottom: revert;
      padding-left: revert;
      padding-right: revert;
      padding-top: revert;
      position: revert;
      vertical-align: revert;
    }
  }

  .sticky-apply-button {
    position: fixed;
    bottom: 50px;
    right: calc((100vw - ${MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH}) / 2 + 26px);
    background-color: ${Colors[WHITE_COLOR_NAME]};
    padding: 12px 6px;
    border: 1px solid;
    border-color: ${Colors[WORK_OS_IRIS_COLOR_NAME]};
    color: ${Colors[WORK_OS_IRIS_COLOR_NAME]};
    border-radius: 28px;
    width: 160px;
    z-index: ${LAYER_ONE};
    text-align: center;
    font-size: 1rem;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s ease-in;

    &.visible {
      opacity: 1;
    }

    @media (max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH}) {
      right: 32px;
    }
  }

  .mail-cv-paragraph {
    font-size: 1rem;
    line-height: 24px;

    a {
      color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
    }
  }

  .disability-paragraph {
    font-size: 0.875rem;
    text-align: center;
    margin-right: 25%;
    margin-left: 25%;
    line-height: 1.32;
    border-top: 2px solid #dcdfec;
    border-bottom: 2px solid #dcdfec;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 40px;

    a {
      color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH_M}) {
    .disability-paragraph {
      margin-top: 50px;
      margin-right: 10%;
      margin-left: 10%;
    }

    .mail-cv-paragraph {
      text-align: center;
      margin-right: 10%;
      margin-left: 10%;
    }
  }

  .section-position-heading {
    .title {
      font-weight: bold;
      font-size: 2.7rem;
      line-height: 114.1%;
      /* or 55px */
      letter-spacing: -0.002em;
      color: #383b45;
    }

    .position-subtitle {
      margin-top: 30px;
      margin-bottom: 31px;

      font-weight: bold;
      font-size: 1.125rem;
      line-height: 120%;
      /* identical to box height, or 24px */

      letter-spacing: -0.105px;

      color: #383b45;
      display: flex;
      justify-content: center;
      align-items: center;

      > span {
        margin: 0 18px;

        display: flex;
        align-items: center;
        justify-content: center;

        > span.circle {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: inline-block;
          margin-right: 15px;
        }

        img,
        .clock-icon {
          margin-top: 4px;
          margin-right: 15px;
        }

        &.etype {
          .clock-icon.full-time {
            fill: #00c875;
          }

          .clock-icon.part-time {
            fill: #fdab3d;
          }
        }
      }
    }
  }

  .section-position-details {
    padding-top: 0;

    .side-content {
    }

    .careeers-position-info {
      max-width: 755px;

      .position-text {
        h2, h3, h4 {
          margin: 2em 0 0.5em 0;
          font-weight: bold;
          font-size: 1.375rem;
          line-height: 32px;
          color: #383b45;

          &:first-child {
            margin-top: 0;
          }
        }

        h3 {
          font-size: 1.2rem;
        }

        h4 {
          font-size: 1.1rem;
        }

        p {
          font-size: 1rem;
          line-height: 26px;
          margin-bottom: 1em;
        }

        .position-text-wrapper {
          color: #383b45;
          font-size: 1rem;
          line-height: 26px;

          a {
            color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
          }

          ul {
            padding: 0 1em 0 1em;

            li {
              list-style-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEuMjUyOTcgMy42MDkzM0MxLjA0Mzk3IDMuMzg2MTggMC43MDUxMDggMy4zODYxOCAwLjQ5NjEwNiAzLjYwOTMzQzAuMjg3MTA1IDMuODMyNDkgMC4yODcxMDUgNC4xOTQzIDAuNDk2MTA2IDQuNDE3NDVMMi42MzY4MyA2LjcwMzE3QzIuODQ1ODMgNi45MjYzMyAzLjE4NDY5IDYuOTI2MzMgMy4zOTM2OSA2LjcwMzE3TDcuNjc1MTQgMi4xMzE3NEM3Ljg4NDE0IDEuOTA4NTggNy44ODQxNCAxLjU0Njc3IDcuNjc1MTQgMS4zMjM2MkM3LjQ2NjE0IDEuMTAwNDYgNy4xMjcyOCAxLjEwMDQ2IDYuOTE4MjggMS4zMjM2MkwzLjAxNTI2IDUuNDkwOThMMS4yNTI5NyAzLjYwOTMzWiIgZmlsbD0iIzYxNjFGRiIvPgo8L3N2Zz4K");
              padding-left: 0.5em;
              padding-bottom: 0.5em;

              p {
                margin-bottom: 0;
              }
            }
          }
        }
      }

      .copy-shareable-link {
        font-style: normal;
        font-weight: normal;
        font-size: 0.8125rem;
        line-height: 22px;
        color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
        padding-left: 30px;
        background-image: url("data:image/svg+xml;base64,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");
        background-position: 0 1px;
        background-repeat: no-repeat;
      }

      .copy-shareable-link :hover {
        &.is-not-clicked {
          color: ${Colors[BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01]};
          background-image: url("data:image/svg+xml;base64,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");
        }
      }
    }
  }

  /* this is located in desktop's .side-content, and in mobile's .section-mobile-apply */

  .comeet-widget-container {
    min-height: 624px;
    margin-bottom: 15px;
    padding: 23px 20px 0 20px;
    background: #ffffff;
    box-shadow: 0 4.97118px 9.94235px rgba(0, 0, 0, 0.101025);
    border-radius: 30px;

    .title {
      margin-top: 23px;
      font-weight: bold;
      font-size: 2.25rem;
      line-height: 40px;
      letter-spacing: -0.375605px;

      text-align: center;
      color: #323338;
    }
  }

  .section-team-details {
    max-width: 930px;
    margin: 0 auto;

    .meet-the-title {
      font-weight: bold;
      font-size: 2.7rem;
    }

    .team-images-container {
      img.team-img {
        max-width: 852px;
        width: 100%;
        margin-bottom: 45px;
      }
    }

    .team-images-carousel-container {
      padding: 0 32px;

      .carousel-item {
        .picture-component {
          display: inline-block;
        }
      }

      .carousel .slick-slider.focus .slick-list .slick-track {
        padding-bottom: 0;
        padding-top: 0;
      }

      img.team-img {
        max-width: 852px;
        width: 100%;
        padding: 0 64px;
      }

      .carousel-arrow-wrapper {
        cursor: pointer;
        z-index: ${TOP_LAYER};
        text-align: center;
        width: 64px;
        height: 64px;
        outline: revert;

        &:before {
          display: none;
        }

        &:hover {
          svg path {
            fill: ${colors[WORK_OS_IRIS_COLOR_NAME]};
          }
        }

        svg {
          height: 100%;
          width: 16px;

          path {
            fill: ${colors.mud};
            transition: fill 0.2s ease-in-out;
          }
        }
      }
    }
  }

  .section-startupforstartup {
    color: #383b45;

    h2.title {
      font-weight: 700;
      font-size: 2.25rem;
      line-height: 50px;

      /* padding l/r leaves space for 'in-margin' bg image (800 + 2*130 = 960) */
      width: 960px;
      padding: 20px 60px 50px 130px;
      margin: 0 auto;
      background: url("data:image/svg+xml;base64,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") no-repeat 0 0;
    }

    h2.subtitle {
      font-size: 1.375rem;
      font-weight: 400;
      line-height: 32px;
    }

    h4.subtitle {
      font-weight: normal;
      font-size: 1.375rem;
      line-height: 40px;
      letter-spacing: -0.3px;
      margin-bottom: 40px;
    }

    .sfs-links-container {
      /* padding l/r leaves space for 'in-margin' bg image (930 + 2*105 = 1140) */
      width: 1140px;
      padding: 0 105px;
      background: url(${generateCloudinaryImageUrl("/static/img/careers/sfs_bg.png")}) no-repeat 0 0;
      margin: 0 auto;

      .sfs-link {
        display: inline-block;

        .sfs-link-box {
          position: relative;
          width: 458px;
          height: 192px;
          margin: 0 8px;
          padding: 30px 138px 30px 26px;
          color: #383b45;
          border-radius: 8px;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1723);

          background: white url(${generateCloudinaryImageUrl("/static/img/careers/play.png")}) no-repeat 354px 24px;

          h4 {
            font-weight: normal;
            font-size: 1.75rem;
            line-height: 36px;
          }

          .langs {
            position: absolute;
            left: 26px;
            bottom: 20px;

            font-size: 0.8125rem;
            line-height: 22px;
            color: #808080;
          }

          .platforms {
            position: absolute;
            right: 26px;
            bottom: 20px;

            background: url(${generateCloudinaryImageUrl("/static/img/careers/sfs_platforms.png")}) no-repeat right center;
            padding-right: 90px;

            font-size: 0.8125rem;
            line-height: 22px;
            color: #383b45;
          }
        }
      }
    }
  }

  .section-team-specific-content {
    margin-top: 0;
    padding-top: 15px;

    .two-tone-title {
      font-size: 1.575rem;
      line-height: 50px;
      letter-spacing: -0.165px;
      color: #383b45;
      margin-bottom: 50px;
    }

    .design-youtube-link {
      text-align: center;
      margin-bottom: 150px;

      iframe[src*="youtube"] {
        display: block;
        margin: 0 auto;
        max-width: 100%;
      }
    }

    .design-instagram-link {
      margin-bottom: 95px;

      img.image {
        width: 100%;
        max-width: 1284px;
      }
    }

    .design-dribble-link {
      svg {
        display: block;
        margin: 0 auto;
      }

      font-weight: bold;
      color: #fb275d;
      font-size: 1rem;
      line-height: 50px;
      letter-spacing: -0.165px;
    }
  }

  /* DESKTOP DESIGN */
  @media (min-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .accordion-holder {
      .accordion-header {
        /* hide accordion button */

        > svg {
          display: none;
        }
      }
    }
  }

  /* MOBILE DESIGN */
  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .sticky-apply-button {
      display: none;
    }

    .has-mobile-padding {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }

    .has-mobile-narrow-padding {
      padding-left: 1rem;
      padding-right: 1rem;
    }

    .section-position-heading {
      background: #f9fafb;
      padding-bottom: 2rem;

      .title {
        font-weight: normal;
        font-size: 2.025rem;
        line-height: 120%;
        letter-spacing: -0.02em;
        margin-bottom: 20px;
      }

      .position-subtitle {
        margin-top: 0;
        font-size: 0.8125rem;
        line-height: 120%;
        font-weight: normal;

        letter-spacing: -0.105px;

        > span {
          margin: 0 10px;

          &:first-child {
            margin-left: 0;
          }

          &:last-child {
            margin-right: 0;
          }

          > span.circle {
            width: 16px;
            height: 16px;
            margin-right: 10px;
            vertical-align: top;
          }
        }

        img,
        .clock-icon {
          height: 16px;
          margin-right: 10px !important;
        }

        .clock-icon {
          margin-top: 0 !important;
        }
      }
    }

    .section-position-details {
      padding-left: 0;
      padding-right: 0;

      /* CUSTOM ACCORDION - DESIGN SPECIFICS FOR MOBILE POSITION PAGE (overrides common style, used also in mobile careers page) */

      .accordion-holder {
        padding: 1.3rem 0 0.5rem 0;

        .accordion-header {
          position: relative;

          > svg {
            top: 7px;
          }
        }

        .accordion-content {
          position: relative;
          border-bottom: 1px solid #e6e9ef;

          .position-text-wrapper {
            font-size: 0.875rem;
            line-height: 24px;
          }

          .has-padding-0 {
            .position-text-wrapper {
              padding-bottom: 0;
            }
          }
        }

        &:not(.is-active) {
          .accordion-content {
            max-height: 100px;

            &:after {
              position: absolute;
              content: "";
              width: 100%;
              height: 30px;
              bottom: 0;
              left: 0;

              background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 200%);
              transform: rotate(-180deg);
            }
          }
        }

        &.is-active {
          .accordion-content {
            max-height: none;
            overflow: visible;
          }
        }
      }
    }

    .section-team-details {
      padding-left: 0;
      padding-right: 0;

      .title {
        font-weight: bold;
        font-size: 1.375rem;
        line-height: 24px;
        letter-spacing: -0.02em;
        margin-bottom: 40px;
      }

      .team-images-container {
        img.team-img {
          margin-top: -1px;
          display: block;
          margin-bottom: 0;
        }
      }
    }

    .section-startupforstartup {
      padding-left: 0;
      padding-right: 0;

      h2.title {
        padding: 0;
        background: none;
        font-weight: bold;
        font-size: 1.375rem;
        line-height: 32px;
        width: 340px;
        margin-bottom: 32px;
      }

      h2.subtitle {
        font-size: 1.125rem;
      }

      h4.subtitle {
        font-weight: normal;
        font-size: 0.6875rem;
        line-height: 22px;
        letter-spacing: -0.02em;
        color: #383b45;
        width: 340px;
        margin-left: auto;
        margin-right: auto;
      }

      .sfs-links-container {
        background: url(${generateCloudinaryImageUrl("/static/img/careers/sfs_bg_mobile.png")}) no-repeat left bottom;
        padding-bottom: 77px;

        padding-left: 1rem;
        padding-right: 1rem;
        width: unset;

        .sfs-link {
          display: block;

          .sfs-link-box {
            width: 100%;
            max-width: 100%;
            margin: 0;
            height: unset;
            min-height: 150px;
            padding: 18px 130px 25px 15px;
            background: white;

            h4 {
              font-weight: normal;
              font-size: 1.375rem;
              line-height: 32px;
              letter-spacing: -0.03em;
            }

            .langs {
              left: 15px;
            }

            .platforms {
              right: 15px;
              font-weight: bold;
            }

            &:after {
              content: "";
              position: absolute;
              right: 12px;
              top: 20px;
              background: white url(${generateCloudinaryImageUrl("/static/img/careers/play.png")}) no-repeat 0 0;
              background-size: 44px 44px;
              width: 44px;
              height: 44px;
            }
          }
        }
      }
    }

    .section-team-specific-content {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 50px;

      .two-tone-title {
        font-size: 1.375rem;
        line-height: 32px;
        letter-spacing: -0.02em;
        width: 360px;
        margin-left: auto;
        margin-right: auto;
        font-weight: 200;
      }

      a.anchor-holder {
        padding: 20px 5px 30px 3px;
      }

      .card-news {
        width: calc(100vw - 100px);

        .card-content {
          padding: 1rem;

          > p {
            font-size: 1.375rem;
            line-height: 30px;
            /* or 125% */

            letter-spacing: -0.222642px;
          }
        }

        .card-image {
          img {
            margin: 0 auto;
          }
        }

        .card-footer {
          p {
            font-size: 0.563rem;
            line-height: 16px;
            letter-spacing: -0.0779248px;
            color: ${Colors.asphalt};
          }
        }
      }

      .slick-dots {
        bottom: unset;
        top: -30px;

        li button {
          background: #f2f3f4 !important;
        }

        li.slick-active button {
          background: ${Colors[WORK_OS_IRIS_COLOR_NAME]} !important;
        }
      }
    }

    .section-mobile-apply {
      padding: 0 13px;

      .title {
        text-align: center;
      }

      .comeet-widget-container {
        padding: 20px 20px 0 20px;
        margin-bottom: 0;
        min-height: 360px;
      }
    }

    .section-mobile-share {
      padding-top: 50px;
      margin-top: -13px;
    }
  }

  ${slickThemeStyle}
  ${slickStyle}
`;
